import React, {ReactElement} from 'react';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import DateIcon from '../MyIcons/DateIcon';

const DateInput = (props: any): ReactElement => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <KeyboardDatePicker
        disableToolbar
        format={'MM/dd/yyyy'}
        id="date-picker-inline"
        inputVariant="outlined"
        KeyboardButtonProps={{
          'aria-label': 'change date'
        }}
        autoOk={true}
        helperText={''}
        error={false}
        keyboardIcon={<DateIcon />}
        {...props}
        // style={{width: '8.2vw'}}
      />
    </MuiPickersUtilsProvider>
  );
};
export default DateInput;
